import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Utils         from 'utils';


import ProfilingEazyGender from '@common/influencer/parts/profiling/profiling-eazy-gender';
import ProfilingGeneGender from '@common/influencer/parts/profiling/profiling-gene-gender';
import ProfilingWordcloud  from '@common/influencer/parts/profiling/profiling-wordcloud';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class PostPreview extends React.Component {
  refreshAction() {
    let chk = confirm('プロファイリング結果の更新を行います。よろしいですか？');
    if( chk == false ) return;
    
    let report = this.props.detail.report;
    
    Utils.request.bind(this)('/api/influencer/refresh_report_profiling', { insta_user_id: report.insta_user_id, report_id: report.id, project_id: report.project_id },
      function(res){
        this.props.base.event.updateData('report', res.body.report);
        alert('プロファイリングの再取得を開始しました。完了まで少々お待ち下さい。');
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let _html = null;
    
    let detail = this.props.detail;
    
    let like_list = [];
    try { if( like_list != null ) like_list = detail.report.like_list.split(','); } catch(e) {}
    
    if( detail.report == undefined || like_list.length < 10 ){
      _html = (
        <div className="influencer-profiling post-none">いいね数が10未満の投稿はプロファイリングを表示できません</div>
      );
    }
    
    let profiling = detail.report.profiling;
    let wordcloud = detail.report.wordcloud;
    if( profiling == null ){
      _html = (
        <div className="influencer-profiling post-none">プロファイリングデータの取得中です</div>
      );
    }
    
    if( _html == null ){
      let man_per = 0;
      try {
        let json = JSON.parse(profiling);
        for( let i in json ) if( i.indexOf('M.') >= 0 ) man_per += json[i];
      } catch(e) {}
      
      _html = (
        <div className="post-profiling">
          <div className="gender-generation">
            <ProfilingEazyGender title="フォロワーの性別比" mode="graph" profiling={{ man_per: man_per, woman_per: (100 - man_per) }} />
            <ProfilingGeneGender title="フォロワーの年代/性別比" mode="graph" profiling={profiling} />
          </div>
          <ProfilingWordcloud title="フォロワーのワードクラウド" wordcloud={wordcloud} />
        </div>
      );
    }
    
    return (
      <div className="modal-item influencer-profiling">
        {_html}
        
        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>プロファイリングデータの更新</Tooltip>}>
          <a className="refresh-link" onClick={this.refreshAction.bind(this)}><i className="material-icons">refresh</i></a>
        </OverlayTrigger>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default PostPreview;